/**
 * Collection that holds {maxSize} number of items and their sorting direction.
 * Will add new entries, or move existing entries, to the front and go to their next direction following the scheme 'none' -> 'ascending' -> 'descending'.
 *
 */
export class SortTable {
    constructor(maxSize) {
        this.sortArray = [];
        this.maxSize = 2;
        this.maxSize = maxSize !== null && maxSize !== void 0 ? maxSize : 2;
    }
    find(headerRef) {
        let idx = this.sortArray.findIndex(item => item.headerRef === headerRef);
        if (idx > -1)
            return this.sortArray[idx];
        return null;
    }
    addSort(headerRef, direction) {
        //if new and < max addsort, if max remove last and addsort, if old chgdir
        let idxItem = this.sortArray.findIndex(item => item.headerRef === headerRef);
        if (idxItem > -1) { //exists
            let item = this.sortArray.splice(idxItem, 1)[0];
            if (direction)
                item.sortDir = direction;
            else
                this.nextDirection(item); //nxt dir
            if (item.sortDir !== '')
                this.sortArray.splice(0, 0, item); //move to front if has dir
            else
                this.sortArray.push(item); //move to back to still get the default sort
        }
        else { //shift to front of array
            let item = {
                headerRef: headerRef,
                sortDir: ''
            };
            if (direction)
                item.sortDir = direction;
            else
                this.nextDirection(item); //nxt dir
            this.sortArray.unshift(item);
            if (this.sortArray.length > this.maxSize)
                this.sortArray.splice(-1); //rm last entry if above max size
        }
        return this.sortArray;
    }
    nextDirection(item) {
        switch (item.sortDir) {
            case '':
                item.sortDir = 'ascending';
                break;
            case 'ascending':
                item.sortDir = 'descending';
                break;
            case 'descending':
                item.sortDir = '';
                break;
        }
    }
}
//# sourceMappingURL=SortTable.js.map